import React from "react";
import PropTypes from "prop-types";

const EditIcon = ({ height = "18", width = "18", viewBox = "0 0 18 18" }) => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7774 2.9675L15.5324 4.7225C15.8249 5.015 15.8249 5.4875 15.5324 5.78L14.1599 7.1525L11.3474 4.34L12.7199 2.9675C12.8624 2.825 13.0499 2.75 13.2449 2.75C13.4399 2.75 13.6274 2.8175 13.7774 2.9675ZM2.25 13.4375V16.25H5.0625L13.3575 7.95498L10.545 5.14248L2.25 13.4375ZM4.43998 14.7498H3.74998V14.0598L10.545 7.2648L11.235 7.9548L4.43998 14.7498Z"
        fill="#C6554F"
      />
    </svg>
  );
};

EditIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  viewBox: PropTypes.string,
};

export default EditIcon;
